import { useMutation } from "@tanstack/react-query";

import { useNotification } from "base/hooks";

import { exchangeToken as exchangeTokenService } from "../services";
import { TokenData } from "../types";

export const useExchangeToken = (args?: Args) => {
    const notify = useNotification();
    const { mutate: exchangeToken, isPending: isExchangingToken } = useMutation(
        {
            mutationFn: exchangeTokenService,
            onSuccess: tokenData => {
                args?.onSuccess?.(tokenData);
            },
            onError: error => {
                notify("Token exchange failed: " + error, "error");
            },
        },
    );

    return { exchangeToken, isExchangingToken };
};

type Args = {
    onSuccess?(_: TokenData): void;
};
